/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const edit_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.52 16.345.75 23.25l6.905-1.771M2.52 16.345l5.135 5.134M2.52 16.345 16.605 2.26m-8.95 19.219L21.739 7.394m0 0 .415-.415a3.639 3.639 0 0 0 .035-5.169 3.64 3.64 0 0 0-5.17.035l-.414.415m5.134 5.134L16.605 2.26"
    />
  </svg>
)
export default edit_medium
